//全局使用的一些函数
import _this from "../../main";
import router from '../../router'
import moment from 'moment'

export default {
  install(Vue) {

    //================ 用户校验相关

    //根据sessionKey获取用户信息 全局函数
    Vue.prototype.getUserInfo = function (userinfosessionKey, redirect, callback) {
      const _this = this;

      redirect = redirect ? decodeURIComponent(redirect) : undefined;

      //_this.axios.post(_this.$store.state.api.common + 'login/get_userinfo_by_token', _this.qs.stringify({
        //token: userinfosessionKey
      //_this.axios.post(_this.$store.state.api.ev_api + 'restful/checkLogin', _this.qs.stringify({
        //sessionKey: userinfosessionKey
      // _this.axios.post(_this.$store.state.api.insurance_api + 'index_api/get_userinfo_by_token', _this.qs.stringify({
      //   token: userinfosessionKey
      // })).then(function (res) {

      _this.axios.get(_this.$store.state.api.login_api + 'restful/checkLogin', {
        params:{sessionKey: userinfosessionKey}
      }).then(function(res){

        // console.log(res);

        if (res.status == 200) {
          if (typeof res.data != "object") {
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              _this.$router.replace({ path: '/login', query: { redirect: redirect } });
              console.error(error);
              return false;
            }
          }
          if (res.data.status == 0) {
            const fetch_data = res.data.data;
            //console.log(fetch_data);

            let user_data = {
              sessionkey: fetch_data.sessionKey,

              id: fetch_data._user.id,
              username: fetch_data._user.username,
              nickname: fetch_data._user.nickname ? fetch_data._user.nickname : '无昵称',
              name: fetch_data._user.name,
              avatar: fetch_data._user.user_img,

              service_shopno: fetch_data._user.shopNo,//服务门店
              service_dealer: fetch_data._user.dealerCode,//服务门店的上级经销商
              service_sbu: fetch_data._user.sbuCode,//服务门店的上级SBU

              bind_shopno: fetch_data._user.bindShopNo,//店长身份的门店
              bind_dealercode: fetch_data._user.bindDealerCode,
              bind_sbucode: fetch_data._user.bindSbuCode,
              bind_orgcode: '',//所在层级的编号
              //roletype: 1,//经销商


              phone: fetch_data._user.phone_number,
              email: fetch_data._user.email,
              birthday: fetch_data._user.birthday ? fetch_data._user.birthday : '',
              sex: fetch_data._user.sex,//0未知 1女 2男
              address: {
                province_id: fetch_data._user.province_id,//省
                city_id: fetch_data._user.city_id,//市
                country_id: fetch_data._user.country_id,//区县
                address: fetch_data._user.address,//详细地址
              },
              role: [//角色
                // "storeManager",
                // "owner",
              ],





            }

            // if( user_data.shopno ){
            //   user_data.roletype = 0;//门店
            // }

            fetch_data._auth.forEach(function(role_n){
              if( user_data.role.indexOf(role_n.role_code) == -1 ){
                user_data.role.push(role_n.role_code);
              }
              //if(role_n.role_code == "master"){
                //user_data.roletype = 2;//总部
              //}
              if(role_n.role_code == "storeManager"){//店长
                user_data.bind_orgcode = user_data.bind_shopno;//
              } else if(role_n.role_code == "dealer"){//经销商
                user_data.bind_orgcode = user_data.bind_dealercode;//
              } else if(role_n.role_code == "sbu"){//经销商
                user_data.bind_orgcode = user_data.bind_sbucode;//
              }
            });

            //本地存储
            localStorage.setItem('giant_userdata', JSON.stringify(user_data));//session
            //sessionStorage.setItem('user_','#/IndexA');

            //读取
            //console.log( localStorage.getItem('user_data') );
            //console.log( JSON.parse(localStorage.getItem('user_data')) );

            callback && callback();

            //_this.$router.replace({ path: '/'});
            if (redirect) {
              location.replace(redirect);
              if (redirect != './') {
                //location.reload();
              }
            }

            //console.error(res.data.msg ? res.data.msg : '自动登录失败');
            //_this.$router.replace({ path: '/login', query: { redirect: redirect } });
            // _this.$dialog.confirm({
            //   closeOnPopstate: true,//页面回退时自动关闭
            //   title: '登录失效',
            //   message: '出现了一些问题',
            //   showCancelButton: false,
            //   confirmButtonText: '前往opo登录',
            // }).then(() => {
            //   location.replace(_this.$store.state.externalurl.opo);
            // }).catch(() => {
            // });
          } else {
            console.error('自动登录失败——3');
            _this.$router.replace({ path: '/login', query: { redirect: redirect } });
          }

        } else {
          console.error('自动登录失败——2');
          _this.$router.replace({ path: '/login', query: { redirect: redirect } });
          // _this.$dialog.confirm({
          //   closeOnPopstate: true,//页面回退时自动关闭
          //   title: '请求用户失败',
          //   message: '出现了一些问题',
          //   showCancelButton: false,
          //   confirmButtonText: '前往opo登录',
          // }).then(() => {
          //   location.replace(_this.$store.state.externalurl.opo);
          // }).catch(() => {
          // });
        }

      }).catch(function (error) {
        _this.$router.replace({ path: '/login', query: { redirect: redirect } });
        // _this.$dialog.confirm({
        //   closeOnPopstate: true,//页面回退时自动关闭
        //   title: '获取用户信息出错',
        //   message: '出现了一些问题',
        //   showCancelButton: false,
        //   confirmButtonText: '前往opo登录',
        // }).then(() => {
        //   location.replace(_this.$store.state.externalurl.opo);
        // }).catch(() => {
        // });
        console.error(error);
      });
    };

    //刷新sessionKey（token） 全局函数
    //callback 成功，sorryFn 失败
    Vue.prototype.refreshToken = function (callback, sorryFn) {
      const _this = this;

      //如果在App环境中，调用App的刷新Token方法
      if( _this.$store.state.browser.giantevapp ){
        if( _this.$store.state.browser.ios ){
          window.webkit.messageHandlers.reload.postMessage('');
        } else {
          // 小于3.2.2调用Android， 大于等于3.2.2 使用android
          if(_this.checkEVGiantAppVersion('3.2.2',"3.2.2")){
            window.android.reload('');
          }else{
            window.Android.reload('');
          }
        }
        return false;
      }

      // _this.axios.post(_this.$store.state.api.insurance_api + 'index_api/refresh_token', _this.qs.stringify({
      //   token: _this.$store.state.loginUser.sessionkey
      // })).then(function (res) {


      _this.axios.get(_this.$store.state.api.login_api + 'restful/refreshLogin', {
        params:{sessionKey: _this.$store.state.loginUser.sessionkey}
      }).then(function(res){



        // console.log(res);

        if (res.status == 200) {
          if (typeof res.data != "object") {
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              console.error(error);
              if (sorryFn) {
                if (typeof sorryFn == "function") {
                  sorryFn();
                } else {
                  _this.$dialog.confirm({
                    closeOnPopstate: true,//页面回退时自动关闭
                    title: res.data.msg,
                    message: '您可以尝试：',
                    confirmButtonText: '重新登录',
                    cancelButtonText: '刷新重试'
                  }).then(() => {
                    _this.$router.replace({ path: '/login', query: { redirect: location.href } });
                    //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath } });
                  }).catch(() => {
                    location.reload(true);
                  });
                }
              }
              return false;
            }
          }
          if (res.data.status == 0) {

            let user_data = JSON.parse(localStorage.getItem('giant_userdata'));

            if( res.data.data._status ){
              user_data.sessionkey = res.data.data.sessionKey;
            } else {
              _this.$router.replace({ path: '/login', query: { redirect: location.href } });
              return false;
            }

            //本地存储
            localStorage.setItem('giant_userdata', JSON.stringify(user_data));//session

            _this.$store.commit('updateLoginUser', user_data);

            //const fetch_data = res.data.data;
            //console.log(fetch_data);
            if (typeof callback == "function") {
              setTimeout(function () {
                callback();
              }, Math.ceil(Math.random() * 500));//增加<500毫秒的延时
            }

          } else if (res.data.status == 3) {//token有误，已无效
            _this.$router.replace({ path: '/login', query: { redirect: location.href } });
            //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath } });
            return false;
            //_this.$toast(res.data.msg);
            if (sorryFn) {
              if (typeof sorryFn == "function") {
                sorryFn();
              } else {
                _this.$dialog.confirm({
                  closeOnPopstate: true,//页面回退时自动关闭
                  title: res.data.msg,
                  message: '您可以尝试：',
                  confirmButtonText: '重新登录',
                  cancelButtonText: '返回上一页'
                }).then(() => {
                  _this.$router.replace({ path: '/login', query: { redirect: location.href } });
                  //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath } });
                }).catch(() => {
                  history.back();
                });
              }
            }
          } else {
            //_this.$toast('更新令牌出现了一些问题');
            if (sorryFn) {
              if (typeof sorryFn == "function") {
                sorryFn();
              } else {
                _this.$dialog.confirm({
                  closeOnPopstate: true,//页面回退时自动关闭
                  title: res.data.msg ? res.data.msg : '更新令牌出现了一些问题',
                  message: '您可以尝试：',
                  confirmButtonText: '重新登录',
                  cancelButtonText: '返回上一页'
                }).then(() => {
                  _this.$router.replace({ path: '/login', query: { redirect: location.href } });
                  //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath } });
                }).catch(() => {
                  history.back();
                });
              }
            }
          }

        } else {
          //_this.$toast('请求更新令牌失败');
          if (sorryFn) {
            if (typeof sorryFn == "function") {
              sorryFn();
            } else {
              _this.$dialog.confirm({
                closeOnPopstate: true,//页面回退时自动关闭
                title: '请求更新令牌失败',
                message: '您可以尝试：',
                confirmButtonText: '重新登录',
                cancelButtonText: '返回上一页'
              }).then(() => {
                _this.$router.replace({ path: '/login', query: { redirect: location.href } });
                //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath } });
              }).catch(() => {
                history.back();
              });
            }
          }
        }

      }).catch(function (error) {
        console.error(error);
        if (sorryFn) {
          if (typeof sorryFn == "function") {
            sorryFn();
          } else {
            _this.$dialog.confirm({
              closeOnPopstate: true,//页面回退时自动关闭
              title: '更新令牌出现异常',
              message: '您可以尝试：',
              confirmButtonText: '重新登录',
              cancelButtonText: '返回上一页'
            }).then(() => {
              _this.$router.replace({ path: '/login', query: { redirect: location.href } });
              //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath } });
            }).catch(() => {
              history.back();
            });
          }
        }
      });
    };

    //================ 工具相关

    //返回上一页
    Vue.prototype.backToPrevpage = function () {
      const _this = this;
      router.go(-1);
    };

    //复制到剪贴板
    Vue.prototype.copyToClipboard = function (content) {
      const _this = this;
      if (window.clipboardData) {
        window.clipboardData.setData('text', content);
      } else {
        (function (content) {
          document.oncopy = function (e) {
            e.clipboardData.setData('text', content);
            e.preventDefault();
            document.oncopy = null;
          }
        })(content);
        document.execCommand('Copy');
      }
    };

    //页面滚动到，全局函数
    //https://stackoverflow.com/questions/21474678/scrolltop-animation-without-jquery
    Vue.prototype.scrollToTop = function (duration = 500, targettop = 100, linear = false) {
      // cancel if already on top
      if (document.scrollingElement.scrollTop === targettop) return;
      if (linear) {
        const cosParameter = document.scrollingElement.scrollTop - targettop;
        let scrollY = cosParameter, oldTimestamp = null;
        let firstTimestamp = null;//通过时间戳判断何时终止
        function step(newTimestamp) {
          if (firstTimestamp === null) {
            firstTimestamp = newTimestamp;
          }
          if (oldTimestamp !== null) {
            scrollY -= cosParameter * (newTimestamp - oldTimestamp) / duration;
            //if (scrollY > -10 && scrollY < 10) return document.scrollingElement.scrollTop = targettop;
            if (oldTimestamp - firstTimestamp >= duration) return document.scrollingElement.scrollTop = targettop;
            document.scrollingElement.scrollTop = targettop + scrollY;
          }
          oldTimestamp = newTimestamp;
          window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      } else {
        const cosParameter = (targettop - document.scrollingElement.scrollTop) / 2;
        let scrollCount = 0, oldTimestamp = null;
        function step(newTimestamp) {
          if (oldTimestamp !== null) {
            // if duration is 0 scrollCount will be Infinity
            scrollCount += Math.PI * (newTimestamp - oldTimestamp) / duration;
            if (scrollCount >= Math.PI) return document.scrollingElement.scrollTop = targettop;
            document.scrollingElement.scrollTop = targettop - (cosParameter + cosParameter * Math.cos(scrollCount));
          }
          oldTimestamp = newTimestamp;
          window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      }
    };

    //通过经纬度计算距离，返回公里数
    Vue.prototype.calcDistance = function (lat1, lng1, lat2, lng2) {
      function Rad(d) {
        return d * Math.PI / 180.0;//经纬度转换成三角函数中度分表形式。
      }
      var radLat1 = Rad(lat1);
      var radLat2 = Rad(lat2);
      var a = radLat1 - radLat2;
      var b = Rad(lng1) - Rad(lng2);
      var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
        Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
      s = s * 6378.137;// EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000; //输出为公里
      //s=s.toFixed(4);
      return s;
    };

    //获取用户当前位置（定位）
    Vue.prototype.getUserPostion = function (mustReFresh = false, fnCallback, fnError) {
      const _this = this;

      if (!mustReFresh) {//非强制刷新
        let tmpUserpostion = JSON.parse(localStorage.getItem('giant_userpostion'));
        if (tmpUserpostion && tmpUserpostion.lat) {
          fnCallback && fnCallback(tmpUserpostion);
        } else {
          _this.getUserPostion(true, fnCallback, fnError);
        }
        return false;
      }

      window.onGaodeLoad = function () {
        _this.getUserPostion(mustReFresh, fnCallback, fnError);
      }
      if (typeof (AMap) == "undefined") {
        var url = 'https://webapi.amap.com/maps?v=2.0&key=90bc3da9e0445dd5885581a43922d93c&callback=onGaodeLoad';
        var jsapi = document.createElement('script');
        jsapi.charset = 'utf-8';
        jsapi.src = url;
        document.head.appendChild(jsapi);
      } else {
        let map, geolocation;
        map = new AMap.Map(document.createElement('div'), {
          //resizeEnable: true
        });
        map.plugin('AMap.Geolocation', function () {
          geolocation = new AMap.Geolocation({
            enableHighAccuracy: true, //是否使用高精度定位，默认:true
            timeout: 10000, //超过10秒后停止定位，默认：无穷大
          });
          geolocation.getCurrentPosition(function (status, result) {
            if (status == 'complete') {
              //console.log(result.position);

              let userpostion_data = {
                lat: result.position.getLat(),//高精 //result.position.lat
                lng: result.position.getLng(),//高精 //result.position.lng
              }
              //console.log(userpostion_data);

              //本地存储
              localStorage.setItem('giant_userpostion', JSON.stringify(userpostion_data));//session

              fnCallback && fnCallback(userpostion_data);

            } else {
              //onError(result)
              //alert(2);
              fnError && fnError(result);
            }
          });
        });

      }


    };

    //美化价格的显示 num 待美化的价格 fixed 几位小数 round 四舍五入 thousand 千位符
    Vue.prototype.priceSexy = function (num, fixed = 2, round = true, thousand = false) {
      if (isNaN(num)) {
        return num;
      }
      if (fixed >= 0) {
        if (round) {
          num = (Number(num)).toFixed(fixed);
        } else {
          num = (Math.floor(num * 100) / 100).toFixed(fixed);
        }
      }
      if (thousand) {
        var numarr = num.split(".");
        if (numarr.length) {
          num = (numarr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
        }
        if (numarr.length > 1 && numarr[1] != "") {
          num = "" + num + "." + numarr[1];
        }
      }
      return num;
    };

    //计算 解决js运算bug
    Vue.prototype.mathcalc = function (a, b, mode = '+') {
      const _this = this;
      if (mode == '-') {//=========================
        let c, d, e;
        try {
          c = a.toString().split('.')[1].length;
        } catch (f) {
          c = 0;
        }
        try {
          d = b.toString().split('.')[1].length;
        } catch (f) {
          d = 0;
        }
        return e = Math.pow(10, Math.max(c, d)), (_this.mathcalc(a, e, '*') - _this.mathcalc(b, e, '*')) / e;
      } else if (mode == '*') {//=========================
        let c = 0,
          d = a.toString(),
          e = b.toString();
        try {
          c += d.split('.')[1].length;
        } catch (f) { }
        try {
          c += e.split('.')[1].length;
        } catch (f) { }
        return Number(d.replace('.', '')) * Number(e.replace('.', '')) / Math.pow(10, c);
      } else if (mode == '/') {//=========================
        let c, d, e = 0, f = 0;
        try {
          e = a.toString().split('.')[1].length;
        } catch (g) { }
        try {
          f = b.toString().split('.')[1].length;
        } catch (g) { }
        return c = Number(a.toString().replace('.', '')), d = Number(b.toString().replace('.', '')), _this.mathcalc(c / d, Math.pow(10, f - e), '*');
      } else {//=========================
        let c, d, e;
        try {
          c = a.toString().split('.')[1].length;
        } catch (f) {
          c = 0;
        }
        try {
          d = b.toString().split('.')[1].length;
        } catch (f) {
          d = 0;
        }
        return e = Math.pow(10, Math.max(c, d)), (_this.mathcalc(a, e, '*') + _this.mathcalc(b, e, '*')) / e;
      }
    };

    //格式化时间 时间戳、Date 都行
    Vue.prototype.dateformat = function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
      if (dataStr.toString().length < 13) {
        dataStr *= 1000;
      }
      dataStr = Number(dataStr);
      return moment(dataStr).format(pattern);
    };

    //获取时间戳 digit 几位时间戳，默认13位毫秒
    Vue.prototype.pickTimestamp = function (data, digit=13) {
      let tmpTimestamp = new Date().getTime();
      if( data ){
        if( typeof(data) == 'object' ){
          tmpTimestamp = new Date(
            data[0]?data[0]:0, data[1]?data[1]:0, data[2]?data[2]:0,
            data[3]?data[3]:0, data[4]?data[4]:0, data[5]?data[5]:0,
            data[6]?data[6]:0, data[7]?data[7]:0,
          ).getTime();
        } else if( typeof(data) == 'string' ) {
          tmpTimestamp = new Date(data.replace(/-/g, '/')).getTime();
        } else {
          tmpTimestamp = new Date(data).getTime();
        }
      }
      return Number(tmpTimestamp.toString().substr(0, digit));
    };

    //压缩图片
    //width 宽、height 高、quality 质量、longside 长边（优先级高过宽高）、shortside 短边（优先级最高）
    Vue.prototype.compressImage = function (file, callback, config){

      if (file.type == 'image/gif' || file.type == 'image/jpeg' || file.type == 'image/pjpeg' || file.type == 'image/png' || file.type == 'image/x-png') {

        let tmpParams = {
          width: 1000,
          quality: 0.8
        };

        tmpParams = Object.assign(tmpParams, config);

        //通过canvas压缩图片
        var reader = new FileReader();
        reader.readAsDataURL(file.file);
        var img = new Image;
        reader.onload = function (e) {
          //var width = 1080; //图像大小
          //var quality = 0.8; //图像质量
          var canvas = document.createElement("canvas");
          var drawer = canvas.getContext("2d");
          img.src = this.result;
          img.onload = function () {
            canvas.width = img.width;
            canvas.height = img.height;

            if( tmpParams.shortside ){
              if( img.width > img.height ){
                tmpParams.height = tmpParams.shortside;
                tmpParams.width = tmpParams.height * (img.width / img.height);
              } else if( img.height > img.width ){
                tmpParams.width = tmpParams.shortside;
                tmpParams.height = tmpParams.width * (img.height / img.width);
              }
            }else if( tmpParams.longside ){
              tmpParams.width = tmpParams.height = tmpParams.longside;
            }
            if( tmpParams.width && tmpParams.width < img.width ){
              canvas.width = tmpParams.width;
              canvas.height = tmpParams.width * (img.height / img.width);
            }
            if( tmpParams.height && tmpParams.height < canvas.height ){
              canvas.height = tmpParams.height;
              canvas.width = tmpParams.height * (img.width / img.height);
            }
            drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
            let tmpType = 'image/jpeg';
            if( file.file.type == 'image/png' || file.file.type == 'image/x-png' ){
              tmpType = 'image/png';
            }
            file.file = new window.File([_this.dataURItoBlob(canvas.toDataURL(tmpType, tmpParams.quality))], file.file.name, {type: file.file.type});
            _this.uploadFile(file, callback);
          }
        }
      } else {
        _this.uploadFile(file, callback);
      }
    };


    /********************
    http://www.oschina.net/code/snippet_260395_39205

    //WGS-84 to GCJ-02
    GPS.gcj_encrypt(纬,经);

    //GCJ-02 to BD-09
    GPS.bd_encrypt(纬,经);

    //求距离
    GPS.distance(a纬,a经,b纬,b经);

    ********************/
    Vue.prototype.GPS = {
      PI : 3.14159265358979324,
      x_pi : 3.14159265358979324 * 3000.0 / 180.0,
      delta : function (lat, lon) {
          // Krasovsky 1940
          //
          // a = 6378245.0, 1/f = 298.3
          // b = a * (1 - f)
          // ee = (a^2 - b^2) / a^2;
          var a = 6378245.0; //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
          var ee = 0.00669342162296594323; //  ee: 椭球的偏心率。
          var dLat = this.transformLat(lon - 105.0, lat - 35.0);
          var dLon = this.transformLon(lon - 105.0, lat - 35.0);
          var radLat = lat / 180.0 * this.PI;
          var magic = Math.sin(radLat);
          magic = 1 - ee * magic * magic;
          var sqrtMagic = Math.sqrt(magic);
          dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * this.PI);
          dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * this.PI);
          return {'lat': dLat, 'lon': dLon};
      },

      //WGS-84 to GCJ-02
      gcj_encrypt : function (wgsLat, wgsLon) {
          if (this.outOfChina(wgsLat, wgsLon))
              return {'lat': wgsLat, 'lon': wgsLon};

          var d = this.delta(wgsLat, wgsLon);
          return {'lat' : wgsLat + d.lat,'lon' : wgsLon + d.lon};
      },
      //GCJ-02 to WGS-84
      gcj_decrypt : function (gcjLat, gcjLon) {
          if (this.outOfChina(gcjLat, gcjLon))
              return {'lat': gcjLat, 'lon': gcjLon};

          var d = this.delta(gcjLat, gcjLon);
          return {'lat': gcjLat - d.lat, 'lon': gcjLon - d.lon};
      },
      //GCJ-02 to WGS-84 exactly
      gcj_decrypt_exact : function (gcjLat, gcjLon) {
          var initDelta = 0.01;
          var threshold = 0.000000001;
          var dLat = initDelta, dLon = initDelta;
          var mLat = gcjLat - dLat, mLon = gcjLon - dLon;
          var pLat = gcjLat + dLat, pLon = gcjLon + dLon;
          var wgsLat, wgsLon, i = 0;
          while (1) {
              wgsLat = (mLat + pLat) / 2;
              wgsLon = (mLon + pLon) / 2;
              var tmp = this.gcj_encrypt(wgsLat, wgsLon)
              dLat = tmp.lat - gcjLat;
              dLon = tmp.lon - gcjLon;
              if ((Math.abs(dLat) < threshold) && (Math.abs(dLon) < threshold))
                  break;

              if (dLat > 0) pLat = wgsLat; else mLat = wgsLat;
              if (dLon > 0) pLon = wgsLon; else mLon = wgsLon;

              if (++i > 10000) break;
          }
          //console.log(i);
          return {'lat': wgsLat, 'lon': wgsLon};
      },
      //GCJ-02 to BD-09
      bd_encrypt : function (gcjLat, gcjLon) {
          var x = gcjLon, y = gcjLat;
          var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * this.x_pi);
          var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * this.x_pi);
          var bdLon = z * Math.cos(theta) + 0.0065;
          var bdLat = z * Math.sin(theta) + 0.006;
          return {'lat' : bdLat,'lon' : bdLon};
      },
      //BD-09 to GCJ-02
      bd_decrypt : function (bdLat, bdLon) {
          var x = bdLon - 0.0065, y = bdLat - 0.006;
          var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * this.x_pi);
          var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * this.x_pi);
          var gcjLon = z * Math.cos(theta);
          var gcjLat = z * Math.sin(theta);
          return {'lat' : gcjLat, 'lon' : gcjLon};
      },
      //WGS-84 to Web mercator
      //mercatorLat -> y mercatorLon -> x
      mercator_encrypt : function(wgsLat, wgsLon) {
          var x = wgsLon * 20037508.34 / 180.;
          var y = Math.log(Math.tan((90. + wgsLat) * this.PI / 360.)) / (this.PI / 180.);
          y = y * 20037508.34 / 180.;
          return {'lat' : y, 'lon' : x};
          /*
          if ((Math.abs(wgsLon) > 180 || Math.abs(wgsLat) > 90))
              return null;
          var x = 6378137.0 * wgsLon * 0.017453292519943295;
          var a = wgsLat * 0.017453292519943295;
          var y = 3189068.5 * Math.log((1.0 + Math.sin(a)) / (1.0 - Math.sin(a)));
          return {'lat' : y, 'lon' : x};
          //*/
      },
      // Web mercator to WGS-84
      // mercatorLat -> y mercatorLon -> x
      mercator_decrypt : function(mercatorLat, mercatorLon) {
          var x = mercatorLon / 20037508.34 * 180.;
          var y = mercatorLat / 20037508.34 * 180.;
          y = 180 / this.PI * (2 * Math.atan(Math.exp(y * this.PI / 180.)) - this.PI / 2);
          return {'lat' : y, 'lon' : x};
          /*
          if (Math.abs(mercatorLon) < 180 && Math.abs(mercatorLat) < 90)
              return null;
          if ((Math.abs(mercatorLon) > 20037508.3427892) || (Math.abs(mercatorLat) > 20037508.3427892))
              return null;
          var a = mercatorLon / 6378137.0 * 57.295779513082323;
          var x = a - (Math.floor(((a + 180.0) / 360.0)) * 360.0);
          var y = (1.5707963267948966 - (2.0 * Math.atan(Math.exp((-1.0 * mercatorLat) / 6378137.0)))) * 57.295779513082323;
          return {'lat' : y, 'lon' : x};
          //*/
      },
      // two point's distance
      distance : function (latA, lonA, latB, lonB) {
          var earthR = 6371000.;
          var x = Math.cos(latA * this.PI / 180.) * Math.cos(latB * this.PI / 180.) * Math.cos((lonA - lonB) * this.PI / 180);
          var y = Math.sin(latA * this.PI / 180.) * Math.sin(latB * this.PI / 180.);
          var s = x + y;
          if (s > 1) s = 1;
          if (s < -1) s = -1;
          var alpha = Math.acos(s);
          var distance = alpha * earthR;
          return distance;
      },
      outOfChina : function (lat, lon) {
          if (lon < 72.004 || lon > 137.8347)
              return true;
          if (lat < 0.8293 || lat > 55.8271)
              return true;
          return false;
      },
      transformLat : function (x, y) {
          var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
          ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0;
          ret += (20.0 * Math.sin(y * this.PI) + 40.0 * Math.sin(y / 3.0 * this.PI)) * 2.0 / 3.0;
          ret += (160.0 * Math.sin(y / 12.0 * this.PI) + 320 * Math.sin(y * this.PI / 30.0)) * 2.0 / 3.0;
          return ret;
      },
      transformLon : function (x, y) {
          var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
          ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0;
          ret += (20.0 * Math.sin(x * this.PI) + 40.0 * Math.sin(x / 3.0 * this.PI)) * 2.0 / 3.0;
          ret += (150.0 * Math.sin(x / 12.0 * this.PI) + 300.0 * Math.sin(x / 30.0 * this.PI)) * 2.0 / 3.0;
          return ret;
      }
    };




    //================ 业务相关

    //拉取门店数据
    //funCallback 成功回调 funError 出错回调
    Vue.prototype.getStoreData = function (shopno, token, funCallback, funError) {
      const _this = this;

      //拉取门店信息
      let tmpParams = {
        code: shopno,
        //user_id: token,
      };

      _this.axios.post(_this.$store.state.api.ev_api + 'restful/storeinfo', _this.qs.stringify(tmpParams)).then(function (res) {
        if (res.status == 200) {
          if (typeof res.data != "object") {
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              _this.$toast('拉取门店数据情况未知：接口异常');
              console.error(error);
              return false;
            }
          }
          if (res.data.status == 0) {

            if( res.data.data.result ){

              let fetch_data = res.data.data.store;

              funCallback && funCallback(fetch_data);

            } else {
              if (funError) {
                funError();
              } else {
                _this.$dialog.confirm({
                  title: res.data.data.msg ? res.data.data.msg : '出现了一些问题',
                  message: '您可以尝试：',
                  confirmButtonText: '刷新重试',
                  cancelButtonText: '返回首页'
                }).then(() => {
                  location.reload(true);
                }).catch(() => {
                  _this.$router.replace({ path: '/' });
                });
              }
            }




          } else if (res.data.status == 2) {
            _this.refreshToken(function () {
              _this.getStoreData(shopno, token, funCallback, funError, funConflict, funClosedown);
            }, true);
          } else if (res.data.status == 3) {
            funClosedown && funClosedown(res.data.data ? res.data.data : '【未知门店】');
          } else {
            if (funError) {
              funError();
            } else {
              _this.$dialog.confirm({
                title: res.data.msg ? res.data.msg : '出现了一些问题',
                message: '您可以尝试：',
                confirmButtonText: '刷新重试',
                cancelButtonText: '返回首页'
              }).then(() => {
                location.reload(true);
              }).catch(() => {
                _this.$router.replace({ path: '/' });
              });
            }
          }
        } else {
          if (funError) {
            funError();
          } else {
            _this.$dialog.confirm({
              title: '商品详情拉取失败',
              message: '您可以尝试：',
              confirmButtonText: '刷新重试',
              cancelButtonText: '返回首页'
            }).then(() => {
              location.reload(true);
            }).catch(() => {
              _this.$router.replace({ path: '/' });
            });
          }
        }
      }).catch(function (error) {
        console.error(error);
        if (funError) {
          funError();
        } else {
          _this.$dialog.confirm({
            title: '详情拉取失败',
            message: '您可以尝试：',
            confirmButtonText: '刷新重试',
            cancelButtonText: '返回首页'
          }).then(() => {
            location.reload(true);
          }).catch(() => {
            _this.$router.replace({ path: '/' });
          });
        }


      });

    };


    //根据车架号获取车辆信息
    //funCallback 成功回调 funError 出错回调
    Vue.prototype.getBikeDataByVin = function (vin, funCallback, funError) {
      const _this = this;

      //是否有车架号去请求车辆信息：
      // _this.$store.commit('updatecheck_ByVindata', {
      //   label: 'checkByVindata',
      //   data: vin
      // });

      if(!vin){
        return false;
      }

      let tmpParams = {
        //qrcode: vin,
        vinno: vin,
      };

      //有车架号去请求车辆信息：
      // _this.$store.commit('updatecheck_onByVindata', {
      //   label: 'checkonByVindata',
      //   data: vin
      // });

      _this.axios.post(_this.$store.state.api.ev_api + 'qrcode/getinfoByQRcode', _this.qs.stringify(tmpParams)).then(function (res) {

        // _this.$store.commit('updateonget', {
        //   label: 'bikegetinfo',
        //   data: '开始请求getinfoByQRcode'
        // });

        if (res.status == 200) {
          console.log(res.data)

          // _this.$store.commit('updateBikeNowprevData', {
          //   label: 'bikeNowprevData',
          //   data: res.data
          // });

          if (typeof res.data != "object") {
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              _this.$toast('拉取车辆信息情况未知：接口异常');
              console.error(error);
              return false;
            }
          }

          // _this.$store.commit('updateBikeNownextData', {
          //   label: 'bikeNownextData',
          //   data: res.data
          // });

          if (res.data.result == 1) {

            //let fetch_data = res.data.data;

            funCallback && funCallback(res.data.bike);

          } else {
            if (funError) {
              funError(1);
            } else {
              _this.$dialog.confirm({
                title: res.data.msg ? res.data.msg : '出现了一些问题',
                message: '您可以尝试：',
                confirmButtonText: '刷新重试',
                cancelButtonText: '返回首页'
              }).then(() => {
                location.reload(true);
              }).catch(() => {
                _this.$router.replace({ path: '/' });
              });
            }
          }
        } else {
          _this.$store.commit('updateerror200', {
            label: 'bikegeterror200',
            data: "error200"
          });

          if (funError) {
            funError(2);
          } else {
            _this.$dialog.confirm({
              title: '车辆信息拉取失败',
              message: '您可以尝试：',
              confirmButtonText: '刷新重试',
              cancelButtonText: '返回首页'
            }).then(() => {
              location.reload(true);
            }).catch(() => {
              _this.$router.replace({ path: '/' });
            });
          }
        }
      }).catch(function (error) {
        _this.$store.commit('updateerror', {
          label: 'bikegeterror',
          data: error
        });
        console.error(error);
        if (funError) {
          funError(3);
        } else {
          _this.$dialog.confirm({
            title: '车辆资料拉取失败',
            message: '您可以尝试：',
            confirmButtonText: '刷新重试',
            cancelButtonText: '返回首页'
          }).then(() => {
            location.reload(true);
          }).catch(() => {
            _this.$router.replace({ path: '/' });
          });
        }


      });

      //跳过请求车辆信息：
      // _this.$store.commit('updatecheck_noget', {
      //   label: 'checkonnoget',
      //   data: vin
      // });

    };
    //检测当前车架号是否与App一致
    Vue.prototype.checkVinChange = function (vinno, callback, errorCallback) {
      const _this = this;
      //有无车架号去请求车辆信息
      // _this.$store.commit('updatecheck_prevdata', {
      //   label: 'checkprevdata',
      //   data: vinno
      // });

      if(!vinno){
        localStorage.removeItem("bikenow_data");
        _this.$store.commit("updateState", {
          label: "bikeNow",
          data: false
        });
        return false;
      }

      let tmpCheck = false;
      if (_this.$store.state.bikeNow) {
        if( _this.$store.state.bikeNow.vinno != vinno ){
          tmpCheck = true;
        }
      } else {
        tmpCheck = true;
      }

      //有车架号去请求车辆信息
      // _this.$store.commit('updatecheck_nextdata', {
      //   label: 'checknextdata',
      //   data: vinno
      // });

      //if( tmpCheck ){

        _this.getBikeDataByVin(
          //车架号
          vinno,
          //成功回调
          function(fetch_data) {
            //console.log(fetch_data);

            let bikenow_data = {
              vinno: fetch_data.vinno,
              //vinno: "653621710001211",//653621809825730
              data: fetch_data
            };

            //本地存储
            localStorage.setItem("bikenow_data", JSON.stringify(bikenow_data));

            _this.$store.commit("updateState", {
              label: "bikeNow",
              data: bikenow_data
            });

            callback && callback(tmpCheck);

            //location.reload(true);

          },
          //出错回调
          function(tmp_num) {
            _this.$toast.fail(tmp_num+":车辆信息载入失败");
            errorCallback && errorCallback(tmp_num);
          }
        );

      //}


    };
    //下拉刷新
    Vue.prototype.onRefresh = function(){
      setTimeout(() => {
        this.isLoading = false;
        location.reload(true);
      }, 1000);
    };
    // 判断电动车版本版本
    Vue.prototype.checkEVGiantAppVersion = function (limit_giantappversion, atleast){
      // let agent = "Mozilla/5.0 (Linux; Android 10; PACM00 Build/QP1A.190711.020; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/77.0.3865.92 Mobile Safari/537.36; giantevapp/3.1.3"
      let matches = window.navigator.userAgent.toLowerCase().match(/giantevapp\/([\d]+)\.([\d]+)\.([\d]+)/);
      if( matches ){
        let limit_var = limit_giantappversion.split('.');
        if( atleast ){
          if( Number(matches[1]) > Number(limit_var[0]) ){
            return true;
          } else if( Number(matches[1]) == Number(limit_var[0]) ){
            if( Number(matches[2]) > Number(limit_var[1]) ){
              return true;
            } else if( Number(matches[2]) == Number(limit_var[1]) ){
              return Number(matches[3]) >= Number(limit_var[2]);
            }
          } else {
            return false;
          }
        } else {
          if( Number(limit_var[0]) > Number(matches[1]) ){
            return true;
          } else if( Number(limit_var[0]) == Number(matches[1]) ){
            if( Number(limit_var[1]) > Number(matches[2]) ){
              return true;
            } else if( Number(limit_var[1]) == Number(matches[2]) ){
              return Number(limit_var[2]) > Number(matches[3]);
            }
          } else {
            return false;
          }
        }
      } else {
        return false;
      }

    };
    //骑行app版本 华为系列手机（荣耀）
    Vue.prototype.noInsure = function (){
      let noInsure = 0
      if(_this.$store.state.browser.giantevapp){
          if(_this.$store.state.browser.honor || this.$store.state.browser.huawei){

            if(_this.checkGiantAppVersion('2.17.1',1)){
              noInsure = 1
            }
          }
      }
      return noInsure
    };


  }
}







// WEBPACK FOOTER //
// ./src/assets/js/site.js